import { IntegrationEventsResponse, ProvidersResponse, TestConnectionResponse } from '../../app/pages/integrations/types'
import { apiClient } from '../client'

/**
 * Integrations API endpoints
 */
export const integrationsApi = {
  /**
   * Get integrations list
   */
  getList: async (params?: string): Promise<any> => {
    const url = params ? `/integrations/?${params}` : '/integrations/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get integration by ID
   */
  getById: async (integrationId: string): Promise<any> => {
    const { data } = await apiClient.get(`/integrations/${integrationId}/`)
    return data
  },

  /**
   * Create integration
   */
  create: async (payload: any): Promise<any> => {
    const { data } = await apiClient.post('/integrations/', payload)
    return data
  },

  /**
   * Update integration
   */
  update: async (integrationId: string, payload: any): Promise<any> => {
    const { data } = await apiClient.patch(`/integrations/${integrationId}/`, payload)
    return data
  },

  /**
   * Delete integration
   */
  delete: async (integrationId: string): Promise<void> => {
    await apiClient.delete(`/integrations/${integrationId}/`)
  },

  /**
   * Get field mapping info
   */
  getFieldMappingInfo: async (): Promise<any> => {
    const { data } = await apiClient.get('/integrations/field-mapping-info/')
    return data
  },

  /**
   * Get available providers and their config schemas
   */
  getProviders: async (): Promise<ProvidersResponse> => {
    const { data } = await apiClient.get('/integrations/providers/')
    return data
  },

  /**
   * Get dispatch events (paginated)
   */
  getEvents: async (integrationId: string, page: number = 1): Promise<IntegrationEventsResponse> => {
    const { data } = await apiClient.get(`/integrations/${integrationId}/events/?page=${page}`)
    return data
  },

  /**
   * Get integration events statistics
   */
  getStatistics: async (integrationId: string): Promise<any> => {
    const { data } = await apiClient.get(`/integrations/${integrationId}/events/statistics/`)
    return data
  },

  /**
   * Test connection for an integration
   */
  testConnection: async (integrationId: string): Promise<TestConnectionResponse> => {
    const { data } = await apiClient.post(`/integrations/${integrationId}/test-connection/`)
    return data
  },
}
